export default [
  {
    path: '/user',
    component: () => import('@/components/layouts/user-layout.vue'),
    meta: { authenticated: true, activeUser: true, title: 'User' },
    children: [
      {
        path: '',
        meta: { title: 'User' },
        redirect: { name: 'user#profile' },
      },
      {
        name: 'user#profile',
        path: 'profile',
        meta: { title: 'Profile' },
        component: () => import('@/views/user/profile-view.vue'),
      },
      {
        name: 'user#preferences',
        path: 'preferences',
        meta: { title: 'Preferences' },
        component: () => import('@/views/user/preferences-view.vue'),
      },
      {
        name: 'user#security',
        path: 'security',
        meta: { title: 'Security' },
        component: () => import('@/views/user/security-view.vue'),
      },
      {
        name: 'user#api',
        path: 'api',
        meta: { title: 'API' },
        component: () => import('@/views/user/api-view.vue'),
      },
      {
        name: 'user#upload',
        path: 'upload',
        meta: { title: 'Upload' },
        component: () => import('@/views/user/upload-view.vue'),
      },
    ],
  },
];
